import { render, staticRenderFns } from "./UpdateStatusDisplay.vue?vue&type=template&id=55133166"
import script from "./UpdateStatusDisplay.vue?vue&type=script&lang=js"
export * from "./UpdateStatusDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports